import api from "./api";

export const updateInactivityTimeout = async (inactivityTimeoutMinutes) => {
  const { data } = await api.put("/companySettings/inactivity-timeout", {
    inactivityTimeoutMinutes
  });
  return data;
};

export const getInactivityTimeout = async () => {
  const { data } = await api.get("/companySettings/inactivity-timeout");
  return data;
};
